<div class="narrowed-container">
  <div class="row">
    <div class="col">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h1 class="content-pages-single-title my-6 text-3xl font-bold text-grey-1 md:text-4xl">Relaterade sökningar
        på {{ selectedItem()?.name }}</h1>

      <div class="mb-4">
        <a [routerLink]="backRouterLink()" [title]="'Tillbaka'">&larr; Tillbaka</a>
      </div>

      <ul class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <li *ngFor="let item of categoryItems()">
          <a [routerLink]="item.routerLink" [title]="item.title">{{ item.name }}</a> ({{ item.caregiverUnitsCount }})
        </li>
      </ul>
    </div>

    <div class="col-s">
      <app-sidebar
        [isAdVisible]="true"
        [pageType]="pageType"
      ></app-sidebar>
    </div>
  </div>
</div>
